var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      staticClass: "overflow-hidden"
    },
    [
      _c(
        "v-tabs",
        {
          staticStyle: { "z-index": "1" },
          attrs: {
            "background-color": _vm.$vuetify.theme.themes[_vm.theme].background,
            height: _vm.TABS_HEIGHT
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tab", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.generateMessage("requests.details.titles.property")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-tab",
            [
              !_vm.hasSeenInterventions
                ? _c("v-badge", { attrs: { color: "error" } }, [
                    _c("span", { attrs: { slot: "badge" }, slot: "badge" }, [
                      _vm._v("!")
                    ]),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage(
                            "requests.details.titles.interventions"
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage(
                            "requests.details.titles.interventions"
                          )
                        ) +
                        "\n      "
                    )
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeRecurrence || _vm.isRecurrence,
                  expression: "activeRecurrence || isRecurrence"
                }
              ]
            },
            [
              !_vm.hasSeenRecurrence
                ? _c("v-badge", { attrs: { color: "error" } }, [
                    _c("span", { attrs: { slot: "badge" }, slot: "badge" }, [
                      _vm._v("!")
                    ]),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage(
                            "requests.details.titles.recurrence"
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage(
                            "requests.details.titles.recurrence"
                          )
                        ) +
                        "\n      "
                    )
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-tab", [
            _vm._v(_vm._s(_vm.generateMessage("requests.details.titles.fri")))
          ]),
          _vm._v(" "),
          _c("v-tab", [
            _vm._v(
              _vm._s(_vm.generateMessage("requests.details.titles.logbook"))
            )
          ]),
          _vm._v(" "),
          _c("v-tab", [
            _vm._v(
              _vm._s(_vm.generateMessage("requests.details.titles.documents"))
            )
          ]),
          _vm._v(" "),
          _c("v-tab", [_vm._v("Techniciens")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticClass: "overflow-y-auto overflow-x-hidden",
          style: {
            height: _vm.height + "px",
            background: _vm.$vuetify.theme.themes[_vm.theme].background
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c(
            "v-tab-item",
            [
              _c(
                "loader",
                { attrs: { "is-loading": _vm.isLoadingCurrent } },
                [
                  _c("property-alerts"),
                  _vm._v(" "),
                  _c("property-general"),
                  _vm._v(" "),
                  _c("property-dangerous-situations"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-wrap" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [_c("property-contract")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [_c("property-exploitation")],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("property-specific-symptoms")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-tab-item", [_c("property-interventions")], 1),
          _vm._v(" "),
          _c("v-tab-item", [_c("property-recurrence")], 1),
          _vm._v(" "),
          _c("v-tab-item", [_c("summary-property-sheet")], 1),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("logbook-reduced-filters", {
                style: {
                  height: "80px"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  style: {
                    height: _vm.height - 80 + "px",
                    "overflow-y": "auto"
                  }
                },
                [_c("logbook")],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("documents-horizontal-filters", {
                style: {
                  height: "80px"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  style: {
                    height: _vm.height - 80 + "px",
                    "overflow-y": "auto"
                  }
                },
                [_c("property-documents", { attrs: { "is-modal": "" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            [
              _c("custom-technician-selector-table", {
                attrs: {
                  "entity-id": _vm.request.entity_nav_full_id,
                  "property-id": _vm.request.property_id,
                  request: _vm.request,
                  affectation: false
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }